/**
 * Agend Data Layer - Event Tickets Add to Cart Tracking
 *
 * Tracks when users click "Get Tickets" on event pages
 * and pushes GA4 add_to_cart event to dataLayer.
 */

import { isTrackingEnabled, createItemData, pushAddToCartEvent } from './tracking-utils';

(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		// Check if Event Tickets tracking is enabled
		if (!isTrackingEnabled('eventTicketsEnabled')) {
			return;
		}

		const ticketsButton = document.getElementById('tribe-tickets__tickets-buy');

		// Only proceed if we're on an event page with tickets
		if (!ticketsButton) {
			return;
		}

		/**
		 * Extract ticket data from form using standard GA4 properties
		 */
		function getTicketData() {
			const tickets = [];
			const ticketElements = document.querySelectorAll('[data-ticket-id]');

			ticketElements.forEach(function (ticketElement) {
				const quantityInput = ticketElement.querySelector('input[type="number"]');
				if (!quantityInput) {
					return;
				}

				const quantity = parseInt(quantityInput.value, 10);

				// Only include tickets with quantity > 0
				if (quantity > 0) {
					const nameElement = ticketElement.querySelector('.tribe-tickets__tickets-item-content-title');
					const itemName = nameElement ? nameElement.textContent.trim() : 'Event Ticket';

					// Use shared utility to create item data
					const ticketData = createItemData({
						sku: ticketElement.dataset.sku || '',
						name: itemName,
						price: parseFloat(ticketElement.dataset.ticketPrice) || 0,
						quantity: quantity,
						category: ticketElement.dataset.itemCategory || '',
						stockStatus: ticketElement.dataset.stockStatus || '',
						stockLevel: ticketElement.dataset.stockQuantity
					});

					tickets.push(ticketData);
				}
			});

			return tickets;
		}

		/**
		 * Push add_to_cart event to dataLayer
		 */
		ticketsButton.addEventListener('click', function (e) {
			// Extract ticket data
			const tickets = getTicketData();

			// Push to dataLayer using shared utility
			pushAddToCartEvent(tickets);

			// Form will submit naturally after this event handler completes
		});
	});

})();
